"use client";
'use strict';

var cookies = require('js-cookie');
var React = require('react');
var consts = require('@sravni/utils/lib/consts');
var theme = require('@sravni/utils/lib/theme');
var dom = require('../../utils/dom.js');
var consts$1 = require('./consts.js');
var Context = require('./Context.js');

function ControlledThemeProvider(props) {
    const { theme: theme$1, onChange, children } = props;
    const setTheme = React.useCallback(
    // isTrusted - true if function called by user action
    (theme, isTrusted = true) => {
        if (isTrusted) {
            cookies.set(consts.COOKIES.USER_THEME, theme, {
                expires: new Date(new Date().getTime() + consts$1.COOKIE_MAX_AGE),
                sameSite: 'Lax',
                path: '/',
            });
        }
        onChange(theme);
    }, [onChange]);
    React.useEffect(() => {
        if (!dom.isBrowser) {
            return;
        }
        const node = document.documentElement;
        node?.setAttribute(theme.ATTR_NAME, theme$1);
    }, [theme$1]);
    const value = React.useMemo(() => ({ theme: theme$1, setTheme }), [setTheme, theme$1]);
    return React.createElement(Context.ThemeContext.Provider, { value: value }, children);
}

exports.ControlledThemeProvider = ControlledThemeProvider;
//# sourceMappingURL=Controlled.js.map
